import * as types from './mutation-types'
import {LOAD_DISCOUNT_LIST, LOAD_DISCOUNT_TYPES, SET_CURRENT_PROMOTION, UPDATE_PROMOTION} from "./mutation-types";

export default {
  [types.LOAD_PROMOTIONS](state, data) {
    state.promotions = data.promotions
  },
  [types.ADD_PROMOTION](state, data) {
    state.promotions.push(data)
  },
  [types.SET_CURRENT_PROMOTION](state, data) {
    state.currentPromotion = (data.promotion)
  },
  [types.UPDATE_PROMOTION] (state, data) {
    state.promotions = state.promotions.map((promotion) => { if (promotion.id == data.id) {promotion = data} return promotion })
  },
  [types.LOAD_APPLIES](state, data) {
    state.applies = data
  },
  [types.LOAD_DISCOUNT_TYPES](state, data) {
    state.discountTypes = data
  },
  [types.APPEND_PROMOTION_NOTIFICATION](state, notification) {
    if (state.currentPromotion && Array.isArray(state.currentPromotion.notifications)) {
      state.currentPromotion.notifications.push(notification)
    }
  },
  [types.SET_PENDING_PRODUCTS](state, products) {
    state.pendingProducts = products || []
  },
}
